import { Link } from "react-router-dom";

type Key = "criticism" | "invalidation" | "darvo";

const ALL: Record<Key, { to: string; label: string }> = {
  criticism: {
    to: "/analysis/criticism-patterns-in-text-messages",
    label: "Criticism vs. Character Attack",
  },
  invalidation: {
    to: "/analysis/invalidation-patterns-in-texts",
    label: "Emotional Invalidation",
  },
  darvo: {
    to: "/analysis/darvo-in-text-messages",
    label: "DARVO (Deny-Attack-Reverse)",
  },
};

const CrossLinkFooter = ({ current }: { current: Key }) => {
  const others = (Object.keys(ALL) as Key[]).filter((k) => k !== current);
  return (
    <div className="mt-16 pt-8 border-t border-white/[0.08]">
      <p className="text-[11px] font-mono uppercase tracking-[0.25em] text-white/40 mb-4">
        Related pattern guides
      </p>
      <p className="text-[16px] leading-[1.7] text-white/70">
        Looking for other communication patterns? See our guide on{" "}
        <Link
          to={ALL[others[0]].to}
          className="text-cyan-300/90 hover:text-cyan-200 underline-offset-4 hover:underline transition-colors"
        >
          {ALL[others[0]].label}
        </Link>{" "}
        or{" "}
        <Link
          to={ALL[others[1]].to}
          className="text-cyan-300/90 hover:text-cyan-200 underline-offset-4 hover:underline transition-colors"
        >
          {ALL[others[1]].label}
        </Link>
        .
      </p>
    </div>
  );
};

export default CrossLinkFooter;
